import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Actividades, Ruta_Sesion } from 'generated/graphql';

interface ModalDisplayI {
	tipoModal:
		| 'evaluacion'
		| 'proyectos'
		| 'calendarioSesion'
		| 'sesion'
		| 'evaluacion_sesion'
		| 'sesionInstrumento'
		| 'sesionGuia'
		| 'listaInstrumentos'
		| '';
	display: boolean;
	rutaKey: string;
	rutaSesion: Ruta_Sesion | null;
	actividad: Actividades | null;
	actividadTieneRespuestas?: boolean;
	tipo?: 'individual' | 'grupal';
	numeroEvaluacion?: number | undefined;
}

const initialState: ModalDisplayI = { tipoModal: '', display: false, rutaKey: '', rutaSesion: null, actividad: null };

const modalPlanificacionSlice = createSlice({
	name: 'modalPlanificacion',
	initialState,
	reducers: {
		setModalPlanificacion: (state, action: PayloadAction<ModalDisplayI>) => {
			return action.payload;
		},
		resetModalPlanificacion: () => {
			return initialState;
		}
	}
});

export const { setModalPlanificacion, resetModalPlanificacion } = modalPlanificacionSlice.actions;

export default modalPlanificacionSlice.reducer;
